import React           from "react";
import PropTypes       from 'prop-types';

import Fact            from "./Fact";
import Translations    from '../../../utils/Translations';
import { generateKey } from "../../../utils/CommonUtils";

const Facts = (props) => {

    const getAttributeSizeConfig = () => {
        let value          = "-";
        let iconClass      = "-icon-fact-breast-size";
        let translationKey = "ActorProfileCupSizeTileCaption";

        if(props?.manPenisSize && props?.isMale){
            value  = props.manPenisSize;
            iconClass      = '-icon-fact-penis-size';
            translationKey = 'ActorProfilePenisSizeTileCaption';
        } else if(props?.cupSizePlain) {
            value  = props.cupSizePlain;
        }

        return {iconClass, translationKey, value };
    };

    const getValue = (valueToGet) => {

        let propKey, unity;
        switch(valueToGet) {
            case 'size':
                propKey = props?.size;
                unity   = "CM";
                break;
            case 'distance':
                propKey = parseInt(props?.distance);
                unity   = "KM";
                break;
            case 'weight':
                propKey = props?. weight;
                unity   = "KG";
                break;
            case 'zip':
                propKey = props.zip;
                unity   = "XXX";
        }

        let Value = "-";
        if(propKey){
            Value = ([
                <span key={generateKey(`about_me-${valueToGet}`, 0)}>{propKey}</span>,
                <span
                    key={generateKey(`about_me-${valueToGet}`, 1)}
                    className="context-box__tile--property__value-unit"
                >{unity}</span>
            ]);
        }
        return <span className="context-box__tile--property__value">{Value}</span>;
    };

    const factsTitleText = props?.isCouple
        ? ( props?.isAboutMyPartner
            ? Translations.get('actor_profile.about_me-facts.couple-partner')
            : Translations.get('actor_profile.about_me-facts.couple-me')
        ) : props.isOverview
            ? (
                Translations.get('actor_profile.about_me-facts.solo-overview', props.actorName)
            ) : Translations.get('actor_profile.about_me-facts.solo') ;

    const titleTag   = props?.isOverview ? 'p' : 'h3';
    const titleClass = props?.isOverview ? 'context-box__title' : 'content-box__body__headline';

    const title      = React.createElement( titleTag, {className: titleClass}, factsTitleText );
    const isGermany  = props?.country === "DE";

    const sizeConfig = {
        iconClass:      props.isMale ? '-icon-fact-male-height' : '-icon-fact-female-height',
        translationKey: "actor_profile.about_me-facts-size",
        value:          getValue('size', props),
    };
    const weightConfig = {
        iconClass:      "-icon-fact-weight",
        translationKey: "actor_profile.about_me-facts-weight",
        value:          getValue('weight', props)
    };

    const factsConfig = [
        {
            iconClass:      "-icon-fact-age",
            translationKey: "actor_profile.about_me-facts-age",
            value:          props.age ?? '-'
        },
        props.isOverview && (props.zip && props.country) ? {
            iconClass:      isGermany ? "-icon-fact-country" : "-icon-fact-languages",
            translationKey: isGermany ? "ActorProfileZipTileCaption" : "GuestProfileBasicPropertiesCountry",
            value:          isGermany ? getValue('zip', props) : Translations.get(`model_country_${props.country?.toLowerCase()}`)
        } : {
            iconClass:      "-icon-fact-distance",
            translationKey: "actor_profile.about_me-facts-distance",
            value:          getValue('distance', props)
        },

        props.isOverview ? {...sizeConfig} : {...weightConfig},

        props.isOverview ? {...weightConfig} : {...sizeConfig},

        props.isOverview ? {...getAttributeSizeConfig()} : {
            iconClass:       "-icon-fact-orientation",
            translationKey : "actor_profile.about_me-facts-sexuality",
            value:           props.sexuality ?? '-'
        },
        props.isOverview ? {
            iconClass:      "-icon-fact-sex",
            translationKey: "actor_profile.about_me-facts-gender",
            value:          props.gender ?? '-'
        } : {...getAttributeSizeConfig()}
    ];

    return (
        <section className={props?.isOverview ? "overview-infobox-container" : "about-facts"}>
            {title}

            <div className={"about-facts_facts-container "+ (!props?.isOverview && "about-facts_facts-container--bias")}>
                {factsConfig.map((fact, index) => {
                    if(fact){
                        return <Fact key={generateKey('fact', index)} {...fact} />;
                    }
                })}
            </div>
        </section>
    );
};

Facts.propTypes = {
    name:             PropTypes.string,
    age:              PropTypes.number,
    country:          PropTypes.string,
    cupSizePlain:     PropTypes.string,
    distance:         PropTypes.number,
    gender:           PropTypes.string,
    isAboutMyPartner: PropTypes.bool,
    isCouple:         PropTypes.bool,
    isMale:           PropTypes.bool,
    manPenisSize:     PropTypes.string,
    sexuality:        PropTypes.string,
    size:             PropTypes.number,
    weight:           PropTypes.number,
    zip:              PropTypes.string
};

export default Facts;
